import { getAPIGatewayDataFromParent } from "../handler/ParentDataHandler";

export const METRICS_ALERT = "METRICS_ALERT";
export const STARTED = "STARTED";

export const WIVS_TASK_STATUSES = {
  ACTIVE: "ACTIVE",
  STARTED: "STARTED",
  RESOLVED: "RESOLVED",
};

export const getTasks = (stationCode) => {
  const request = getTaskAPIGatewayRequest("/getTasks", {
    nodeId: stationCode,
  });
  return getAPIGatewayDataFromParent(request);
};

export const getTaskById = (taskId) => {
  const request = getTaskAPIGatewayRequest("/getTask", { taskId });
  return getAPIGatewayDataFromParent(request);
};

function getTaskAPIGatewayRequest(resourcePath, requestBody) {
  return {
    resourcePath,
    httpMethod: "post",
    processName: "workItemVisibilityService",
    requestBody,
  };
}



// WEBPACK FOOTER //
// ./src/components/network/WIVSNetwork.js